import BrowserStorageCache from "./BrowserStorageCache";

class SessionStorageCache extends BrowserStorageCache {
    constructor() {
        super(sessionStorage);
    }
}

export default SessionStorageCache;